import React, { Component } from 'react'
import { Table, Tooltip,Progress } from 'antd'
import Preloader from '../../common/Preloader'
import NewHeader from '../../common/NewHeader'
import SideNav from '../../common/SideNav'
import ResultModal from '../../common/Modals/AddClinicHospital'
import NewFooter from '../../common/NewFooter'
import ajax from '../../utils/ajax';
import functions from '../../utils/functions'
import ReviewPrescriptionToAcceptOrder from '../../common/Modals/ReviewPrescriptionToAcceptOrder'


class PendingOrders extends Component {

    state = {
        userId: functions.sessionGuard(),
        review: false,
        dialog: false,
        isActive: false,
        hospitalsList: false,
        hosId: "",
        prescriptionId:"",
        presciptionImage:"",
        reorderId:"",
        clientId:""
        
    };

    componentDidMount() {
        this.getAllPendingPrescriptions();
    }

    recievedStateReview = (data) => {
        this.setState({ reschedule: data })
    }

    onClickRegister = () => {
      this.setState({ dialog: true })
    }

    //<Progress strokeColor={{from: '#108ee9',to: '#87d068',}} percent={80} showInfo={false} steps={5} />

    recievedState = (data) => {
      this.setState({ dialog: data })
    }

    getAllPendingPrescriptions = async () => {
        const server_response = await ajax.listOrdersPendingApproval(this.state.userId);
        const tableData = []

        if (server_response.status === "OK") {
             //console.log("lplplplplplplplooo",server_response.details.content)
            server_response.details.content.map((pending) =>
                tableData.push({
                    clientName: pending.pre_order_prescription.pres_client.full_name,
                    clientPhone: pending.pre_order_prescription.pres_client.phone_number,
                    clientId:pending.pre_order_prescription.pres_client.client_id,
                    prescriptionId:pending.pre_order_prescription.pres_id,
                    prescriptionName: pending.pre_order_prescription.pres_name,
                    pendingOrderId: pending.pre_order_id,
                    prescriptionimage:pending.pre_order_prescription.pres_photo,
                    created: pending.created_at.long_date,
                    actioned: pending.prescription_id,
                }),
            )

            this.setState({
               hospitalsList: tableData
            })

        } else {
            //   this.setState({
            //     hospitalsList: "404"
            //   })
        }
    }

    onClickReview = (reorderIds, presciptionImage,clientIds,prescriptionIds) => {
        this.setState({
            reschedule: true,
            reorderId:reorderIds,
            clientId:clientIds,
            prescriptionId:prescriptionIds,
            presciptionImage:presciptionImage
        })
    }

    render() {

        const columns = [
            {
                title: 'Client Name',
                dataIndex: 'clientName',
            },
            {
                title: 'Client Phone',
                dataIndex: 'clientPhone',
            },
            {
                title: 'Precription Name',
                dataIndex: 'prescriptionName',
            },
            {
                title: 'Order ID',
                dataIndex: 'pendingOrderId',
                hidden: true
            },
            {
                title: 'Client ID',
                dataIndex: 'clientId',
                hidden: true
            },
            {
                title: 'Prescription ID',
                dataIndex: 'prescriptionId',
                hidden: true
            },
            {
                title: 'Precription Image',
                dataIndex: 'prescriptionimage',
                hidden: true
            },
            {
                title: 'Was created ',
                dataIndex: 'created',
            },
            {
                title: 'Actions - [ View ]',
                dataIndex: 'actioned',

                className: 'bg-transparent text-right',
                render: (text, records, index) => {
                    return (
                        <div className="text-nowrap">
                            <Tooltip
                                placement="leftTop"
                                title="View to take action "
                                color="#454B1B"
                                key="#f50"
                                style={{ marginRight: "10px" }}
                            >
                                <button
                                    type="button"
                                    className="btn btn-light text-red"
                                    style={{ marginInlineEnd: "10px" }}
                                    onClick={() => this.onClickReview(records.pendingOrderId, records.prescriptionimage,records.clientId,records.prescriptionId)}                                >
                                    View Prescription <i className="fa fa-eye" />
                                </button>

                            </Tooltip>

                        </div>
                    )
                }
            },

        ].filter(item => !item.hidden)

        return (

            <body>
                {/* <!-- begin app --> */}
                <div class="app">
                    {/* <!-- begin app-wrap --> */}
                    <div class="app-wrap">
                        {/* <!-- begin pre-loader --> */}
                        <Preloader />
                        <NewHeader />
                        <div class="app-container">
                            <SideNav />
                            {/* <!-- begin app-main --> */}
                            <div class="app-main" id="main">
                                {/* <!-- begin container-fluid --> */}
                                <div class="container-fluid">
                                    {/* <!-- begin row --> */}
                                    <div class="row">
                                        <div class="col-md-12 m-b-30">
                                            {/* <!-- begin page title --> */}
                                            <div class="d-block d-sm-flex flex-nowrap align-items-center">
                                                <div class="page-title mb-2 mb-sm-0">
                                                    <h1>Orders Pending Review</h1>
                                                </div>
                                                <div class="ml-auto d-flex align-items-center">
                                                    <nav>
                                                        <ol class="breadcrumb p-0 m-b-0">
                                                            <li class="breadcrumb-item">
                                                                <a href="index.html"><i class="ti ti-home"></i></a>
                                                            </li>
                                                            <li class="breadcrumb-item">
                                                                System Settings
                                                            </li>
                                                            <li class="breadcrumb-item active text-primary" aria-current="page">All Pending Prescriptions</li>
                                                        </ol>
                                                    </nav>
                                                </div>
                                            </div>
                                            {/* <!-- end page title --> */}
                                        </div>
                                    </div>
                                    {/* <!-- end row --> */}
                                    {/* <!-- begin row --> */}
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="card card-statistics">
                                                <div class="card-body">

                                                    <div class="datatable-wrapper table-responsive">

                                                        <Table
                                                            columns={columns}
                                                            bordered
                                                            dataSource={this.state.hospitalsList}
                                                            size="small"
                                                            pagination={{ pageSizeOptions: ['10'], showTitle: false, hideOnSinglePage: false }}

                                                        />

                                                        {this.state.dialog ? (
                                                        <ResultModal
                                                            visible={{ visible: true }}
                                                            handleCancel={this.recievedState}
                                                        />
                                                        ) : null}  

                                                        {this.state.reschedule ? (
                                                            <ReviewPrescriptionToAcceptOrder
                                                                visible={{ visible: true, presId: this.state.prescriptionId, presImage: this.state.presciptionImage,reorderId:this.state.reorderId,clientId:this.state.clientId}}
                                                                handleCancel={this.recievedStateReview}
                                                            />
                                                        ) : null}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- end row --> */}
                                </div>
                                {/* <!-- end container-fluid --> */}
                            </div>
                            {/* <!-- end app-main --> */}
                        </div>
                        {/* <!-- end app-container --> */}
                        <NewFooter />
                    </div>
                    {/* <!-- end app-wrap --> */}
                </div>
                {/* <!-- end app --> */}
            </body>

        )
    }
}
export default PendingOrders